<template>
    <div>
        <label :for="id" class="label text-left"><strong>{{labelText}}</strong></label>
        <div class="input-group mb-3">
            <div class="form-control">
                <div class="radioboxes-wrapper" v-for="(item, i) in options" :key="i">
                    <input :id="id+i"
                        type='radio'
                        :value='item.value'
                        v-model='checked'
                        @change="updateValue"
                    />
                    <label class="checkbox-label" :for="id+i">{{ item.text }}</label>
                </div>
            </div>
            <div class="input-group-append" v-if="typeof value === 'boolean' || value === undefined">
                <span class="input-group-text text-success" v-b-tooltip.hover :title="tooltipTitle">
                    <font-awesome-icon style="margin: auto" icon="check"/>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormRadioBoxes",
    props: {
        labelText: String,
        value: Boolean,
        tooltipTitle: String,
        options: Array
    },
    data() {
        return {
            id: Date.now() + '-' + Math.random().toString(36).substring(7),
            checked: this.value
        }
    },
    methods: {
        updateValue () {
            // Emit an 'input' event and pass along the updated items array
            this.$emit('input', this.checked)
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.label {
    font-size: 0.8em;
    display: block;
    margin: 0;
    margin-left: 10px;
}
.input-group-text {
    width: 45px;
}
.radioboxes-wrapper {
    display:inline-block; margin-right: 10px;
}
.radioboxes-wrapper * {
    cursor: pointer;
}
.checkbox-label {
    vertical-align: text-top; padding-left: 0.5em;
}
</style>